import { render } from "./TransitionSettings.vue?vue&type=template&id=0a105024"
import script from "./TransitionSettings.vue?vue&type=script&lang=js"
export * from "./TransitionSettings.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__